module.exports = __webpack_public_path__ + "static/media/solo70.c74e15f3.JPG";